import {FC} from 'react'
import {PageLink} from '../../../_metronic/layout/core'
import { CloudPageTitle} from '../../../_metronic/layout/core/CloudPageData'
import {KTCard} from '../../../_metronic/helpers'
import { Cloud } from './Cloud'
import {ToastContainer} from 'react-toastify'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const CloudRiskWrapper: FC = () => {

  return (
    <>
      <CloudPageTitle
        icon='Cloud.svg'
        title='Clouds'
        // desc={totalVendor.toString() + ' Vendors'}
        desc={'1 connected cloud'}
        breadcrumbs={usersBreadcrumbs}
      >
        Cloud
      </CloudPageTitle>
      <KTCard>
        <Cloud className='card-xl-stretch mb-xl-8' />
      </KTCard>
      <ToastContainer />
    </>
  )
}

export default CloudRiskWrapper
